/**
 * Hook: useSettings
 *
 * Public hook for accessing settings context.
 * Following the pattern from useScheduledMeetings.
 *
 * @example
 * ```tsx
 * const { profile, updateProfile, isLoadingProfile } = useSettings();
 *
 * // Update profile
 * await updateProfile({
 *   displayName: 'John Doe',
 *   gravatarEmail: 'john@example.com'
 * });
 * ```
 */

import { useContext } from 'react';
import { SettingsContext } from '../SettingsProvider';

export const useSettings = () => {
  const context = useContext(SettingsContext);

  if (!context) {
    throw new Error('useSettings must be used within SettingsProvider');
  }

  return context;
};
